export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11003.53c3cf2a.jpg";